import {finalize} from 'rxjs/operators';
import {BasePage} from './../../base.page';
import {TranslateService} from '@ngx-translate/core';
import {Router, ActivatedRoute} from '@angular/router';
import {ChatService} from 'src/app/services/chat.service';
import {AuthService} from 'src/app/services/auth.service';
import {UserService} from 'src/app/services/user.service';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {OfferDetailModel, ProductModel} from 'src/app/models/wardrobe.model';
import {WardrobeService} from './../../../services/wardrobe.service';
import {FavoriteService} from 'src/app/services/favorite.service';
import {ErrorHandlerService} from 'src/app/services/error-handler.service';
import {
  Platform,
  LoadingController,
  ToastController,
  ModalController,
} from '@ionic/angular';
import {SubscribeNowModalComponent} from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';
import {
  SwapRequestItemModalComponent
} from 'src/app/components/swap-request-item-modal/swap-request-item-modal.component';
import {
  SwapRequestPaymentModalComponent
} from 'src/app/components/swap-request-payment-modal/swap-request-payment-modal.component';
import {OfferService} from 'src/app/services/offer.service';
import {
  STATUS_ACCEPTED,
  STATUS_REJECTED,
  STATUS_PROCESSING,
  STATUS_CANCELED
} from 'src/app/constants/general.constant';
import {PaginatedResponse} from 'src/app/models/paginated-response.model';
import {ImageZoomComponent} from 'src/app/components/image-zoom/image-zoom.component';

@Component({
  selector: 'shc-product-detail',
  templateUrl: './product-detail.page.html',
  styleUrls: ['./product-detail.page.scss'],
})
export class ProductDetailPage extends BasePage implements OnInit {
  productId: number;
  // activeSlide: number;
  product: ProductModel;
  STATUS_ACCEPTED: string = STATUS_ACCEPTED;
  STATUS_REJECTED: string = STATUS_REJECTED;
  STATUS_PROCESSING: string = STATUS_PROCESSING;
  STATUS_CANCELED: string = STATUS_CANCELED;
  offers: PaginatedResponse<OfferDetailModel>;
  @ViewChild('swiper') swiperRef: ElementRef | undefined;


  slideOpts = {
    initialSlide: 0,
    speed: 400,
    autoHeight: true,
    breakpoints: {
      640: {
        slidesPerView: 1.6,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 1,
      },
      1199: {
        slidesPerView: 1,
      },
    },
  };
  isDifferentUser: boolean;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private wardrobeService: WardrobeService,
    private chatService: ChatService,
    private offerService: OfferService,
    private favoriteService: FavoriteService,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
    );
  }

  async handleImgClick(imageUrl: string) {
    const modal = await this.modalCtrl.create({
      component: ImageZoomComponent,
      cssClass: 'custom-zoom-modal',
      canDismiss: true,
      id: 'custom-zoom-modal',
      componentProps: {
        imageUrl: imageUrl,
      },
    });
    return await modal.present();
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    // this.activeSlide = 0;
    this.productId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.getWardrobeDetail();
  }

  productNotFound = false;

  getWardrobeDetail() {
    this.showLoader();
    this.wardrobeService
      .productDetail(this.productId)
      .pipe(
        finalize(async () => {
          await this.hideLoader();
        }),
      )
      .subscribe(
        (res) => {
          console.log('RESP=>>', res);
          this.product = res;
        },
        (error) => {
          if (error?.status === 404) {
            this.productNotFound = true;
          } else {
            this.errorService.handle(error);
          }
        },
      );
  }

  formatDate(dateStr: string): string {
    if (!dateStr) {
      return '';
    }
    const lang = this.translate?.currentLang || 'nl';
    return new Intl.DateTimeFormat(lang, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date(dateStr));
  }

  toggleFavorite() {
    if (!this.product) {
      return;
    }
    this.product.favorited = !this.product.favorited;
    this.favoriteService.toggleFavorite(this.product.id).subscribe(
      (res) => {
        this.product.favorited = res.favorited;
      },
      (error) => {
        this.product.favorited = !this.product.favorited;
        this.errorService.handle(error);
      },
    );
  }

  routeToEditProduct() {
    this.router.navigate(['wardrobe', 'edit', this.product.id]);
  }

  // slideChanged(ev: any) {
  //   console.log(this.swiperRef?.nativeElement.swiper.activeIndex);
  //   this.activeSlide = this.swiperRef?.nativeElement.swiper.activeIndex;
  //   // this.swiperRef.getActiveIndex().then((index: number) => {
  //   //   console.log(index);
  //   //   this.activeSlide = index;
  //   // });
  // }

  followUser(id: number) {
    // if (!this.user.is_premium) {
    //   this.subscribeNow();
    //   return;
    // }

    this.userService.toggleFollowUser(id).subscribe(
      (res) => {
        this.product.user.is_following = !this.product.user.is_following;
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  routeToUser(id: number) {
    this.router.navigate(['user', id]);
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      mode: 'md',
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async requestSwap() {
    const modal = await this.modalCtrl.create({
      component: SwapRequestItemModalComponent,
      componentProps: {
        sender: this.user,
        product: this.product,
      },
      cssClass: 'requestSwapModal',
      canDismiss: true,
      id: 'swapRequestItem',
      showBackdrop: true,
      mode: 'md',
    });
    modal.onDidDismiss().then((event) => {
      const {data, role} = event;
      if (role == 'confirm' && data) {
        this.product.swap_request_offer = data;
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  acceptOwnedSwapRequest(id: number): void {
    this.offerService.updateOffer(id, STATUS_ACCEPTED).subscribe(
      (res) => {
        this.product.incoming_swap_request = res;
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  declineOwnedSwapRequest(id: number): void {
    this.offerService.updateOffer(id, STATUS_REJECTED).subscribe(
      () => {
        this.wardrobeService.productDetail(this.productId).subscribe((res) => {
          this.product = res;
        });
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  declineOffer(id): void {
    this.offerService.updateOffer(id, STATUS_REJECTED).subscribe(
      (res) => {
        this.errorService.showToast('Swap canceled');
        this.router.navigate(['/tabs/home']);
        // const index = this.offers.data.findIndex(off => off.id === id);
        // if (this.offers.data[index].offer_type === OFFER_TYPE_SWAP_REQUEST) {
        //   // this.refreshOfferList('');
        // }
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  sendChatRequest(productId: number) {
    if (this.product?.chat_id) {
      this.router.navigate(['chat', this.product?.chat_id]);
    } else {
      this.chatService.sendChatRequest({p_id: productId}).subscribe(
        (res) => {
          console.log(res);
          this.router.navigate(['chat', res?.id]);
        },
        (error) => {
          this.errorService.handle(error);
        },
      );
    }
    // this.chatService.sendChatRequest({ p_id: productId }).subscribe(
    //   res => {
    //     console.log(res);
    //     this.router.navigate(['chat', res?.id]);
    //   },
    //   error => {
    //     this.errorService.handle(error);
    //   }
    // )
  }

  sendSwapRequest(productId: number) {
    // Chat already started skip swap request
    if (this.product?.chat_id) {
      this.router.navigate(['chat', this.product?.chat_id]);
      return;
    }

    //
    this.requestSwap();
  }

  // cancelSwapRequest(id: number) {
  //   // Chat already started skip swap request
  //   if (this.product?.chat_id) {
  //     this.router.navigate(['chat', this.product?.chat_id]);
  //     return;
  //   }

  //   this.declineOffer(id);
  // }


  cancelSwapRequest(id: number) {
    this.wardrobeService.productDetail(this.productId).subscribe(res => {
      this.product = res;
      // console.log("cancelSwapRequest this.product, this.user?.id", this.product, this.user?.id);

      // if (this.user?.id !== this.product?.user?.id) {
      //   this.isDifferentUser = true;
      // }

      if (this.product?.chat_id) {
        this.router.navigate(['chat', this.product?.chat_id]);
        return;
      }

      this.cancelOffer(id);
    });
  }

  cancelOffer(id): void {
    this.offerService.updateOffer(id, STATUS_CANCELED).subscribe(
      (res) => {
        // this.errorService.showToast('Swap canceled');
        this.errorService.showToast(this.translate.instant('Toast.swop-cancel'));
        this.router.navigate(['/tabs/home']);
        // const index = this.offers.data.findIndex(off => off.id === id);
        // if (this.offers.data[index].offer_type === OFFER_TYPE_SWAP_REQUEST) {
        //   // this.refreshOfferList('');
        // }
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  finalizeSwapRequest() {
    if (
      !this.product?.swap_request_offer?.id ||
      this.product?.swap_request_offer?.status !== STATUS_ACCEPTED
      // this.product?.swap_request_offer?.purchased
    ) {
      return;
    }

    // Check if user has [premium]
    if (this.user?.is_premium === 1) {
      // skip the payment modal;
      this.errorService.handle('User has premium subscription');
      console.log('User has premium subscription');
    } else {
      this.swapRequestPaymentModal();
    }
  }

  async swapRequestPaymentModal() {
    const modal = await this.modalCtrl.create({
      component: SwapRequestPaymentModalComponent,
      componentProps: {
        product: this.product,
        page: this,
      },
      canDismiss: true,
      id: 'swapRequestPayment',
    });
    modal.onDidDismiss().then((event) => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  navigateToChat() {
    if (!this.product?.chat_id) {
      return;
    }
    // console.log("navigateToChat fun",{
    //     queryParams: {
    //       offerStatus: this.product?.swap_request_offer?.status,
    //       productId: this.product?.id
    //     }
    //   })
    // return
    this.router.navigate(['chat', this.product?.chat_id]);
    // this.router.navigate(
    //   ['chat', this.product.chat_id],
    //   {
    //     queryParams: {
    //       offerStatus: this.product?.swap_request_offer?.status,
    //       productId: this.product?.id,
    //       chatId: this.product.chat_id,
    //     }
    //   }
    // );
  }

  sendRequest(productId: number) {
    if (this.product?.chat_id) {
      this.router.navigate(['chat', this.product?.chat_id]);
    } /* else {
      this.chatService.sendChatRequest({ p_id: productId }).subscribe(
        res => {
          console.log(res);
          this.router.navigate(['chat', res?.id]);
        }, error => {
          this.errorService.handle(error);
        }
      );
    }*/
  }

}
